import { ThemeProvider as SharedThemeProvider } from '@myosh/design-system/react';
import type { ReactNode } from 'react';
import { useGetThemeQuery } from '@/api/generated/rest-v4-api';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { data } = useGetThemeQuery();

  return <SharedThemeProvider data={data}>{children}</SharedThemeProvider>;
};
